import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useEventDetailsCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        EventDetailsPage: {
          heroBackground: {
            sizes: {
              small_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              medium_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              large_url: {
                url: '/imgs/Rebranding/petterns/asphalt.png',
              },
            },
            alt: 'Asphalt background',
          },
          bookYourHotel: t('event_details:book_your_hotel'),
          participatingLocations: t('event_details:participating_locations'),
          galleryHeading: t('event_details:gallery_heading'),
          customersPhotos: t('event_details:Customers_Photos'),
          viewAll: t('event_details:view_all'),
          locationsHeading: t('event_details:locations_heading'),
          viewAllReviews: t('event_details:view_all_reviews'),
          save: t('event_details:save'),
          reviews: t('event_details:reviews'),
          aboutEventTitle: t('event_details:about_event'),
          reserveBtnLable: t('event_details:reserve'),
          bookNow: t('event_details:book_now'),
          eagleRider: t('event_details:eagle_rider'),
          motorcycleEventsCapitalLetters: t('event_details:motorcycle_events_captail_letters'),
          contactEagleRider: t('event_details:contact_eaglerider'),
          locationSearchInputPlaceholder: t('event_details:search_by'),
          shareModalTitle: t('event_details:share_event')

        },
         ShareLinkComponent: {
          shareText: t('common_share:share'),
          shareJourney: t('common_share:share_journey'),
          blueRidgeAdventure: t('common_share:blue_ridge_adventure'),
          copyLink: t('common_share:copy_link'),
          whatsApp: t('common_share:whats_app'),
          facebook: t('common_share:facebook'),
          email: t('common_share:email'),
          linkCopiedText: t('common_share:link_copied'),
        },
        ParticipatingLocationsComponent: {
          searchInputPlaceholder: t(
            'common_participating_locations:find_location_by_name',
          ),
          participatingLocationsTitle: t(
            'common_participating_locations:participating_locations',
          ),
          contactUsDialogTitle: t('common_participating_locations:contact_er'),
          showMapBtnText: t('common_participating_locations:show_map'),
          otherLocationsTitle: t(
            'common_participating_locations:other_locations',
          ),
          adressLabel: t('common_participating_locations:address'),
          callButtonLabel: t('common_participating_locations:call'),
          emailButtonLabel: t('common_participating_locations:email'),
          locationButtonLabel: t(
            'common_participating_locations:location_details',
          ),
        },
         GalleryComponent: {
          showAllMedia: t('common_gallery:show_photos'),
        },
           NewMainWidgetComponent: {
          rentMotorcycle: t('common_new_main_widget:rent_motorcycle'),
          allMotorcycleTours: t('common_new_main_widget:all_motorcycle_tours'),
          guidedMotorcycleTours: t('common_new_main_widget:guided_motorcycle_tours'),
          selfDriveMotorcycleTours: t('common_new_main_widget:self_drive_motorcycle_tours'),
          returnToSameLocation: t('common_new_main_widget:return_to_same_location'),
          searchTour: t('common_new_main_widget:search_tour'),
          tourTypeLabel: t('common_new_main_widget:tour_type'),
          countryLabel: t('common_new_main_widget:country_label'),
          stateNameLabel: t('common_new_main_widget:state_name_label'),
          tourTabLabel: t('common_new_main_widget:tour_tab_label'),
          rentalTabLabel: t('common_new_main_widget:rental_tab_label'),
          country: t('common_new_main_widget:country'),
          stateName: t('common_new_main_widget:state_name'),
          futureBookings: t('common_new_main_widget:future_bookings'),
          saveEvenMore: t('common_new_main_widget:save_even_more'),
          rideRoundTripOrOneWay: t('common_new_main_widget:can_ride_rounded_trip_or_one_way'),
          startYourReservation: t('common_new_main_widget:start_your_reservation'),
          pickupLocation: t('common_new_main_widget:pickup_location'),
          choosePickupLocation: t('common_new_main_widget:choose_pickup_location'),
          dropoffLocation: t('common_new_main_widget:dropoff_location'),
          chooseDropoffLocation: t('common_new_main_widget:choose_dropoff_location'),
          sameAsPickupLocation: t('common_new_main_widget:same_as_pickup_location'),
          dropoffLocationError: t('common_new_main_widget:dropoff_location_error'),
          pickupDateLabel: t('common_new_main_widget:pickup_date_label'),
          dropoffDateLabel: t('common_new_main_widget:dropoff_date_label'),
          milesAway: t('common_new_main_widget:miles_away'),
          baseErrorHeader: t('common_new_main_widget:base_error_header'),
          warning: t('common_new_main_widget:warning'),
          warningNote: t('common_new_main_widget:warning_note'),
          saveUpTo: t('common_new_main_widget:save_up_to'),
          closedAlertText: t('common_new_main_widget:closed_alert'),
          timeLabel: t('common_new_main_widget:time'),
          reserveBtnLabel: t('common_new_main_widget:reserve'),
          vehiclesLabel: t('common_new_main_widget:vehicles'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useEventDetailsCMSData };
